import { createStore, applyMiddleware, compose } from 'redux';
import apiMiddleware from 'solumina-web-middleware-promise-api';
import tokenMiddleware from 'solumina-web-token-middleware';
import { UserHistoryMiddleware } from '../middlewares';

import rootReducer from '../reducers';

const middleware = applyMiddleware(apiMiddleware, tokenMiddleware, UserHistoryMiddleware);

// To enable Redux Dev-tool Support
/* eslint-disable no-underscore-dangle */
const composeEnhancers = process.env.NODE_ENV !== 'production'
    && typeof window === 'object'
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify here name, actionsBlacklist, actionsCreators and other options
    }) : compose;
/* eslint-enable */

const store = createStore(rootReducer, composeEnhancers(middleware));

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('../reducers/index.js', () => {
    const newReducer = require('../reducers/index.js').default; // eslint-disable-line global-require, import/extensions
    store.replaceReducer(newReducer);
  });
}

export default store;